<template>
	<div
		@mouseenter="showGraphResume = true"
		@mouseleave="showGraphResume = false"
		class="candash-blueBorder-3"
		:class="{
			'resume-blue-border': showGraphResume,
			'w-100': $route.name.MobilePreviewResume,
		}"
		@click="selectTemplateData"
	>
		<template v-if="templateData.isColumned">
			<div class="small-template d-flex">
				<div style="height: 100%; width: 33.3%">
					<div
						v-html="templateData.columnData[0].data"
						style="width: 100%"
					></div>
					<div
						v-html="templateData.columnData[1].data"
						style="width: 100%"
					></div>
				</div>
				<div style="height: 100%; width: 66.6%">
					<div
						class="d-flex w-100"
						v-for="(row, index) in templateData.rows"
						:key="index"
					>
						<div
							:style="
								index > 0
									? `width: ${svgData.width}%; margin-top: 2px; margin-left: 2px;`
									: `width: ${svgData.width}%; margin-left: 2px;`
							"
							v-for="(svgData, index1) in templateData.rowData[row]"
							:key="index1"
							v-html="svgData.data"
						></div>
						<template v-if="templateData.sharedRow && row === 'row_1'">
							<div style="width: 50%; margin-right: 2px">
								<div
									v-for="(svgData, index2) in templateData.sharedRowData"
									:key="index2"
									v-html="svgData.data"
									style="height: 50%; width: 100%; margin-left: 2px"
								>
									{{ index2 }}
								</div>
							</div>
						</template>
					</div>
					<!-- <div style="width: 66.6%">
          </div> -->
				</div>
			</div>
		</template>
		<template v-else>
			<div class="small-template" @click="selectTemplateData">
				<div style="width: 100%">
					<div
						class="d-flex w-100"
						v-for="(row, index) in templateData.rows"
						:key="index"
						:style="
							index === 0
								? 'height: 24.5%; margin-top:0px;'
								: 'height: 25%; margin-top:2px;'
						"
					>
						<!-- style="height: 25%" -->
						<!-- :style="index > 0 ? `margin-top:1px;` : ''" -->
						<!-- :style="`width: ${svgData.width}%;margin-left: ${svgData.marginLeft}`" -->
						<div
							:style="
								index1 > 0
									? `margin-left:2px;width: ${svgData.width}%;`
									: `margin-left:0px;width: ${svgData.width}%;`
							"
							v-for="(svgData, index1) in templateData.rowData[row]"
							:key="index1"
							v-html="svgData.data"
						></div>
					</div>
				</div>
			</div>
		</template>
	</div>
</template>

<script>
export default {
	name: "Template",
	data() {
		return {
			showGraphResume: false,
		};
	},
	props: {
		templateData: Object,
		templateID: String,
	},
	created() {
		console.log(
			this.templateID,
			this.templateData,
			this.templateData.sharedRowData
		);
	},
	methods: {
		selectTemplateData() {
			this.$emit("select-template", this.templateData);
		},
	},
};
</script>

<style>
.small-template {
	width: 100%;
	height: 100%;
}
</style>
